import { useState, useEffect } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput } from "../../base/CustomInputText";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";

import { ProjectQuota } from "./ProjectDetailContainer";
import { ProjectQuotaData } from "./ProjectData";

interface ArgsType {
    projectId: string,
    projectQuota: ProjectQuotaData;
}

interface ProjectUpdateProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType,
};

ProjectUpdate.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function ProjectUpdate(props:ProjectUpdateProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeUpdateYn, setExecuteUpdateYn] = useState(false);
        

    const [vmMaxCount, setVmMaxCount] = useState(props.args?.projectQuota.vm_max_count || 0);
    const [vcpuMaxCount, setVcpuMaxCount] = useState(props.args?.projectQuota.vcpu_max_count || 0);
    const [memoryMaxCapacityGb, setMemoryMaxCapacityGb] = useState(props.args?.projectQuota.vmemory_max_capacity_mb || 0);
    const [metadataMaxCount, setMetadataMaxCount] = useState(props.args?.projectQuota.metadata_max_count || 0);
    const [keyPairMaxCount, setKeyPairMaxCount] = useState(props.args?.projectQuota.key_pair_max_count || 0);
    const [vmPoolMaxCount, setVmPoolMaxCount] = useState(props.args?.projectQuota.server_group_max_count || 0);
    const [vmPoolMemberMaxCount, setVmPoolMemberMaxCount] = useState(props.args?.projectQuota.server_group_member_max_count || 0);
    const [volumeMaxCount, setVolumeMaxCount] = useState(props.args?.projectQuota.volume_max_count || 0);
    const [volumeSnapshotMaxCount, setVolumeSnapshotMaxCount] = useState(props.args?.projectQuota.snapshot_max_count || 0);
    const [volumeMaxCapacityGb, setVolumeMaxCapacityGb] = useState(props.args?.projectQuota.block_storage_capacity_gb || 0);
    const [networkMaxCount, setNetworkMaxCount] = useState(props.args?.projectQuota.network_max_count || 0);
    const [subnetMaxCount, setSubnetMaxCount] = useState(props.args?.projectQuota.subnet_max_count || 0);
    const [portMaxCount, setPortMaxCount] = useState(props.args?.projectQuota.port_max_count || 0);
    const [routerMaxCount, setRouterMaxCount] = useState(props.args?.projectQuota.router_max_count || 0);
    const [floatingIpMaxCount, setFloatingIpMaxCount] = useState(props.args?.projectQuota.floatingip_max_count || 0);
    const [securityGroupMaxCount, setSecurityGroupMaxCount] = useState(props.args?.projectQuota.security_group_max_count || 0);
    const [securityGroupRuleMaxCount, setSecurityGroupRuleMaxCount] = useState(props.args?.projectQuota.security_group_rule_max_count || 0);
    
    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                const successYn = checkProjectData();
                if(successYn) {
                    setExecuteUpdateYn(true);
                }
            }
            
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(executeUpdateYn) {
            executeUpdateProject();
        }
    }, [executeUpdateYn]);


    function executeResult(result, closeYn, infoMessage) {
        setExecuteUpdateYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function checkProjectData() {
        let message = "";
        let error = false;
        if(!vmMaxCount || !vcpuMaxCount || !memoryMaxCapacityGb || !metadataMaxCount || !keyPairMaxCount ||
            !vmPoolMaxCount || !vmPoolMemberMaxCount || !volumeMaxCount || !volumeSnapshotMaxCount || 
            !volumeMaxCapacityGb || !networkMaxCount || !subnetMaxCount || !portMaxCount || !routerMaxCount ||
            !floatingIpMaxCount || !securityGroupMaxCount || !securityGroupRuleMaxCount) {
            message = t("MESSAGE_PROJECT_INFO_ENTER_ERROR_MESSAGE");
            error = true;
        }
        if(error === true)
            if(props.showMessageCb){
                props.showMessageCb(message);
        }
        return !error;
    }
    function executeUpdateProject() {
        const updatePackageData = {
            project_quota: {
                vm_max_count: Number(vmMaxCount),
                vcpu_max_count: Number(vcpuMaxCount),
                vmemory_max_capacity_mb: Number(memoryMaxCapacityGb),
                metadata_max_count: Number(metadataMaxCount),
                key_pair_max_count: Number(keyPairMaxCount),
                server_group_max_count: Number(vmPoolMaxCount),
                server_group_member_max_count: Number(vmPoolMemberMaxCount),
                network_max_count: Number(networkMaxCount),
                subnet_max_count: Number(subnetMaxCount),
                port_max_count: Number(portMaxCount),
                router_max_count: Number(routerMaxCount),
                floatingip_max_count: Number(floatingIpMaxCount),
                security_group_max_count: Number(securityGroupMaxCount),
                security_group_rule_max_count: Number(securityGroupRuleMaxCount),
                volume_max_count: Number(volumeMaxCount),
                snapshot_max_count: Number(volumeSnapshotMaxCount),
                block_storage_capacity_gb: Number(volumeMaxCapacityGb)
            }
        };
         
        requests.put(PLATFORM_URL.PROJECT + '/' + props.args?.projectId + '/quotas/' + props.args?.projectQuota.project_quota_id, updatePackageData)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
            
        })
        .catch((error) => {
            executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
        });
    }
    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("PROJECT_UPDATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("REGION_NAME_TEXT")}
                            </Text>
                            <CustomTextInput 
                                key={1} 
                                width={570} height={36} 
                                value={props.args?.projectQuota.region_id || ''} 
                                type={"text"} 
                                activeYn={false} 
                                inputCb={(v)=>{}} 
                                warnYn={false} 
                                placeHolderText={t("")}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={style.titleText}>{
                        t("INSTANCE_RESOURCE_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={{flexDirection:"row"}}>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("VM_MAX_COUNT_TEXT")}
                                </Text>
                                <CustomTextInput 
                                    key={2} 
                                    width={100} height={36} 
                                    value={vmMaxCount.toString()}
                                    type={"number"} 
                                    activeYn={true} 
                                    inputCb={setVmMaxCount} 
                                    warnYn={false} 
                                    placeHolderText={t("0")}
                                />
                            </View>
                            <View style={style.rowSecondContainer}>
                                <Text style={style.columnText}>
                                    {t("VCPU_MAX_COUNT")}
                                </Text>
                                <CustomTextInput 
                                    key={3} 
                                    width={100} height={36} 
                                    value={vcpuMaxCount.toString()} 
                                    type={"number"} 
                                    activeYn={true} 
                                    inputCb={setVcpuMaxCount} 
                                    warnYn={false} 
                                    placeHolderText={t("0")}
                                />
                            </View>
                        </View>
                        <View style={{flexDirection:"row"}}>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("MEMORY_MAX_COUNT_TEXT")}(GB)
                                </Text>
                                <CustomTextInput 
                                    key={4} 
                                    width={100} height={36} 
                                    value={memoryMaxCapacityGb.toString()}
                                    type={"number"} 
                                    activeYn={true} 
                                    inputCb={setMemoryMaxCapacityGb} 
                                    warnYn={false} 
                                    placeHolderText={t("0")}
                                />
                            </View>
                            <View style={style.rowSecondContainer}>
                                <Text style={style.columnText}>
                                    {t("KEY_PAIR_MAX_COUNT")}
                                </Text>
                                <CustomTextInput 
                                    key={5} 
                                    width={100} height={36} 
                                    value={keyPairMaxCount.toString()} 
                                    type={"number"} 
                                    activeYn={true} 
                                    inputCb={setKeyPairMaxCount} 
                                    warnYn={false} 
                                    placeHolderText={t("0")}
                                />
                            </View>
                        </View>
                    </View>
                    <Text style={style.titleText}>{
                        t("STORAGE_RESOURCE_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={{flexDirection:"row"}}>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("VOLUME_MAX_COUNT_TEXT")}
                                </Text>
                                <CustomTextInput 
                                    key={6} 
                                    width={100} height={36} 
                                    value={volumeMaxCount.toString()}
                                    type={"number"} 
                                    activeYn={true} 
                                    inputCb={setVolumeMaxCount} 
                                    warnYn={false} 
                                    placeHolderText={t("0")}
                                />
                            </View>
                            <View style={style.rowSecondContainer}>
                                <Text style={style.columnText}>
                                    {t("VOLUME_SNAPSHOT_MAX_COUNT_TEXT")}
                                </Text>
                                <CustomTextInput 
                                    key={7} 
                                    width={100} height={36} 
                                    value={volumeSnapshotMaxCount.toString()} 
                                    type={"number"} 
                                    activeYn={true} 
                                    inputCb={setVolumeSnapshotMaxCount} 
                                    warnYn={false} 
                                    placeHolderText={t("0")}
                                />
                            </View>
                        </View>
                        <View style={{flexDirection:"row"}}>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("VOLUME_MAX_SIZE_TEXT")}(GB)
                                </Text>
                                <CustomTextInput 
                                    key={8} 
                                    width={100} height={36} 
                                    value={volumeMaxCapacityGb.toString()}
                                    type={"number"} 
                                    activeYn={true} 
                                    inputCb={setVolumeMaxCapacityGb} 
                                    warnYn={false} 
                                    placeHolderText={t("0")}
                                />
                            </View>
                        </View>
                    </View>
                    <Text style={style.titleText}>{
                        t("NETWORK_RESOURCE_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={{flexDirection:"row"}}>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("NETWORK_MAX_COUNT_TEXT")}
                                </Text>
                                <CustomTextInput 
                                    key={9} 
                                    width={100} height={36} 
                                    value={networkMaxCount.toString()}
                                    type={"number"} 
                                    activeYn={true} 
                                    inputCb={setNetworkMaxCount} 
                                    warnYn={false} 
                                    placeHolderText={t("0")}
                                />
                            </View>
                            <View style={style.rowSecondContainer}>
                                <Text style={style.columnText}>
                                    {t("SUBNET_MAX_COUNT")}
                                </Text>
                                <CustomTextInput 
                                    key={10} 
                                    width={100} height={36} 
                                    value={subnetMaxCount.toString()} 
                                    type={"number"} 
                                    activeYn={true} 
                                    inputCb={setSubnetMaxCount} 
                                    warnYn={false} 
                                    placeHolderText={t("0")}
                                />
                            </View>
                        </View>
                        <View style={{flexDirection:"row"}}>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("SECURITY_GROUP_MAX_COUNT")}
                                </Text>
                                <CustomTextInput 
                                    key={11} 
                                    width={100} height={36} 
                                    value={securityGroupMaxCount.toString()}
                                    type={"number"} 
                                    activeYn={true} 
                                    inputCb={setSecurityGroupMaxCount} 
                                    warnYn={false} 
                                    placeHolderText={t("0")}
                                />
                            </View>
                            <View style={style.rowSecondContainer}>
                                <Text style={style.columnText}>
                                    {t("SECURITY_GROUP_RULE_MAX_COUNT")}
                                </Text>
                                <CustomTextInput 
                                    key={12} 
                                    width={100} height={36} 
                                    value={securityGroupRuleMaxCount.toString()} 
                                    type={"number"} 
                                    activeYn={true} 
                                    inputCb={setSecurityGroupRuleMaxCount} 
                                    warnYn={false} 
                                    placeHolderText={t("0")}
                                />
                            </View>
                        </View>
                    </View>
                </View> 
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowSecondContainer: {
        marginLeft: 140,
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    statusImg: {
        marginRight: 3
    },
    dataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    }
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}